// This file is automatically generated. Do not edit manually.

import { DeliveryPackageSource } from "src/api/generated/erp/delivery/model/deliveryPackageSource";
import { AggregatedPickingLocation } from "src/api/generated/erp/delivery/service/aggregatedPickingLocation";
import { WarehousePickingObjectLocationView } from "src/api/generated/erp/db/types/tables/warehousePickingObjectLocationView";
import { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle";
import { DeliveryPackageLineSource } from "src/api/generated/erp/delivery/model/deliveryPackageLineSource";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace DeliverySourcePickingApi {
	export async function getAggregatedPickableLocationsForPackageSource(args: {
		source: DeliveryPackageSource;
		purchaseOrderId?: number | null | undefined;
	}): Promise<Array<AggregatedPickingLocation>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliverySourcePicking/getAggregatedPickableLocationsForPackageSource",
			method: "POST",
			data: {
				source: args.source,
				purchaseOrderId: args.purchaseOrderId,
			},
		});
		return response as Array<AggregatedPickingLocation>;
	}

	export async function getPickableLocationsForPackageSource(args: {
		source: DeliveryPackageSource;
		purchaseOrderId?: number | null | undefined;
	}): Promise<Array<WarehousePickingObjectLocationView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliverySourcePicking/getPickableLocationsForPackageSource",
			method: "POST",
			data: {
				source: args.source,
				purchaseOrderId: args.purchaseOrderId,
			},
		});
		return response as Array<WarehousePickingObjectLocationView>;
	}

	export async function printDeliveryPackageSourcePickingList(args: {
		source: DeliveryPackageSource;
		warehousePickingObjectLocationIds?: Array<number> | null | undefined;
		aggregateByPart?: boolean;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliverySourcePicking/printDeliveryPackageSourcePickingList",
			method: "POST",
			data: {
				source: args.source,
				warehousePickingObjectLocationIds: args.warehousePickingObjectLocationIds,
				aggregateByPart: args.aggregateByPart,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function pickPartsToPackage(args: {
		deliveryPackageId: number;
		parts: Array<DeliverySourcePickingApi_PickPartToPackageParams>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliverySourcePicking/pickPartsToPackage",
			method: "POST",
			data: {
				deliveryPackageId: args.deliveryPackageId,
				parts: args.parts,
			},
		});
		return response as void;
	}
}

export interface DeliverySourcePickingApi_PickPartToPackageParams {
	partWarehouseLocationId: number | null | undefined;
	quantityToPickInBaseUnit: number;
	source: DeliveryPackageLineSource;
}
